angular.module('app').controller( 'LoginCtrl', [ '$location', '$log', '$rootScope', '$scope', '$state',
    'aprgettext', 'AprimaAnalytics', 'Bridge', 'configuration', 'ConsentService', 'ContentAttributeService', 'GatewayFactory',
    'LocalStorageRepository', 'LogOffService', 'LoginAssistanceRepository', 'PatientPortalStorageRepository', 'SessionService', 'TransitionManager', 
    'AccountRepository', 'toaster',
        function ($location, $log, $rootScope, $scope, $state,
            gettext, AprimaAnalytics, Bridge, configuration, ConsentService, ContentAttributeService, GatewayFactory,
            LocalStorageRepository, LogOffService, LoginAssistanceRepository, PatientPortalStorageRepository, SessionService, TransitionManager,
            AccountRepository, toaster) {
            'use strict';

            $log.info('LoginCtrl starting up');

            AprimaAnalytics.sendPageView('/Logon');
            LogOffService.logoff();
            SessionService.resetSessionParams();
            PatientPortalStorageRepository.removeActivePatient();

            $scope.errorMessage = '';
            $scope.submitted = false;
            $scope.loading = false;
            $scope.gateways = _.map(_.cloneDeep(configuration.GATEWAYS), function (g) {
                g.display = g.prefix + ' - ' + g.url;
                return g;
            });

            $scope.loginAssistanceInfo = null;

            $scope.model = {
                clientID: LocalStorageRepository.getClientID() || '0',
                userName: LocalStorageRepository.getUserName() || '',
                userId: LocalStorageRepository.getUserID() || null,
                password: '',
                gateway: null,
                practiceName: '',
                practiceTagline: '',
            };

            if(!configuration.DEV_HOSTED) {
                ContentAttributeService.getClientConfig()
                    .then(function (data) {
                        var oldClientId = LocalStorageRepository.getClientID();

                        if(oldClientId !== data.clientId) {
                            LocalStorageRepository.clearAll();
                        }

                        LocalStorageRepository.setClientURL(data.hostUrl);
                        LocalStorageRepository.setClientID(data.clientId);
                        
                        $scope.model.clientID = LocalStorageRepository.getClientID();
                        onLoad();
                    }).catch(function () {
                        $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                        Bridge.createModalAlert({
                            title: gettext('Loading Error'),
                            message: $scope.errorMessage,
                            buttons: [gettext('Okay')]
                        });
                    });
            } else {
                onLoad();
            }

            function loadPracticeInfo() {
                ContentAttributeService.getPracticeInfo(true)
                    .then(function (practiceInfo) {
                        $scope.model.practiceName = practiceInfo.practiceName;
                        $scope.model.practiceTagline = practiceInfo.practiceTagline;
                    })
                    .catch(function () {
                        $scope.model.practiceName = '';
                        $scope.model.practiceTagline = '';
                    });
            }

            function onLoad() {
                loadPracticeInfo();
                getLoginAssistanceInfo();
            }

            function loginProcess() {
                //do not try logging in while trying to login.
                if ($scope.loading) {
                    return;
                }

                if ($scope.loginForm.$invalid) {
                    $scope.submitted = true;
                    return;
                }

                $scope.loading = true;

                GatewayFactory.login(LocalStorageRepository.getClientID(), $scope.model.userName, $scope.model.password, $scope.model.gateway ? $scope.model.gateway.prefix : null, $scope.model.userId)
                    .then(function () {
                        // Broadcast event to start application timeout logic.
                        // Please see 'modules\app\app.js' for application timeout configuration and documentation.
                        $rootScope.$broadcast('IdleStartWatch');

                        SessionService.setPatientAuthenticated(true);
                        if (SessionService.getNewPasswordRequired() === true) {
                            SessionService.setDisplayDashboardToolbar(false);
                            SessionService.setShowHeaderNavigationMenu(false);
                            TransitionManager.transition({appRoute: 'changepassword'});
                        }
                        else if (SessionService.getPracticeConsentAccepted() === true) {
                            SessionService.setDisplayDashboardToolbar(true);
                            SessionService.setShowHeaderNavigationMenu(true);
                            TransitionManager.transition({appRoute: 'dashboard'});
                        }
                        else {
                            SessionService.setDisplayDashboardToolbar(false);
                            SessionService.setShowHeaderNavigationMenu(false);
                            TransitionManager.transition({appRoute: 'loginconsent'});
                        }
                    }, function (err) {
                        $scope.errorMessage = err.message;

                        Bridge.createModalAlert({
                            title: gettext('Login Error'),
                            message: err.message,
                            buttons: [gettext('Okay')]
                        });
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function completeAccount() {
                SessionService.setDisplayDashboardToolbar(true);
                TransitionManager.transition({appRoute: 'accountActivationRequest'});
            }

            function settings() {
                TransitionManager.transition({appRoute: 'loginsettings'});
            }

            function forgotPassword() {
                if (!$scope.model.userName) {
                    toaster.pop('warning', '', gettext('Please provide username and try again.'));
                    return;
                }

                LocalStorageRepository.setUserName($scope.model.userName);

                // see if the user has security questions available before switching to new screen
                AccountRepository.getSecurityQuestions($scope.model.userName, LocalStorageRepository.getClientID())
                    .then(function (data) {
                        if (data) {
                            TransitionManager.transition({appRoute: 'forgotpassword'});
                        } else {
                            toaster.pop('warning', '', gettext('You do not have Security Questions configured. Please contact the practice.'));
                        }
                    }).catch(function () {
                        toaster.pop('warning', '', gettext('You do not have Security Questions configured. Please contact the practice.'));
                    }).finally(function () {
                        $scope.loading = false;
                    });
            }

            function getLoginAssistanceInfo() {
                LoginAssistanceRepository.getLoginAssistanceInformation(LocalStorageRepository.getClientID())
                    .then(function (data) {
                        $scope.loginAssistanceInfo = data;
                        $scope.assistanceInfoLoaded = true;
                    })
                    .catch(function () {
                        $scope.errorMessage = gettext('Unable to retrieve Login Assistance.');
                        Bridge.createModalAlert({
                            title: gettext('Unable to retrieve Login Assistance'),
                            message: $scope.errorMessage,
                            buttons: [gettext('Okay')]
                        });
                    });
            }

            $scope.loginProcess = loginProcess;
            $scope.completeAccount = completeAccount;
            $scope.settings = settings;
            $scope.forgotPassword = forgotPassword;
            $scope.getLoginAssistanceInfo = getLoginAssistanceInfo;
        }
    ]
);

